import React, { FC } from 'react';
import { GenExternalLink, GenNavTile } from '@/components';
import { TypeAccountNavTileFields } from '@/core/generated-types';
import { TypeUserRecord } from '@/lib/api/accountManager/types';
import { constructLegacyCustomerPortalLink } from '@/utils/shopSubdomain';
import { TypeAccountSettingsPageTranslations } from '@/utils/translations/types/TypeAccountSettingsPageTranslations';

export type PasswordTileProps = {
  t: TypeAccountSettingsPageTranslations;
  user: TypeUserRecord;
  tile: TypeAccountNavTileFields;
  locale: string | undefined;
};

const PasswordTile: FC<PasswordTileProps> = ({ t, user, tile, locale }) => {
  const PASSWORD_PLACEHOLDER = '***************';
  const changePasswordLink = constructLegacyCustomerPortalLink(locale, [
    user.uuid,
    'profile-info',
    'update-password',
  ]);

  return (
    <GenNavTile
      title={tile.title}
      subTitle={tile.subheader}
      description={tile.description}
      titleDecorator={
        <GenExternalLink href={changePasswordLink} cta={t.changeCta} />
      }
    >
      <div className="flex flex-row gap-4">
        <p>{t.passwordLabel}</p>
        <p>{PASSWORD_PLACEHOLDER}</p>
      </div>
    </GenNavTile>
  );
};

export default React.memo(PasswordTile);
